import { Ng2StateDeclaration } from '@uirouter/angular';
import { ReportCenterDashboardComponent } from './pages/report-center-dashboard/report-center-dashboard.component';

export const reportCenterState: Ng2StateDeclaration = {
    name: 'base.customer.global.reportcenter',
    url: '/report-center?search',
    views: {
        'content@base.customer.global': {
            component: ReportCenterDashboardComponent,
        },
    },
    params: {
        search: {
            dynamic: true,
            value: '',
        },
    },
    data: {
        title: 'Acquia Web Governance - Report Center',
        /** Shell-facing path for CC breadcrumb/menu sync (see event-bus-bridge.init.ts) */
        shellPath: '/reports',
        shellAliases: ['/reportcenter', '/report-center'],
    },
};

export const REPORT_CENTER_STATES = [reportCenterState];

